<template>
    <div class="center-department-add">
        <center-add-title>{{$t("message.cdepartment.addTitle")}}</center-add-title>
        <slot name="addForm"></slot>
    </div>
</template>

<script>
export default {
    components: {
        centerAddTitle: () => import("@/components/center/centerAddTitle")
    }
}
</script>

<style scoped>
.center-department-add{
    margin-top: 30px;
    padding-bottom: 20px;
    background: #fff;
}
</style>
